import React, { Component } from 'react';
import { FirebaseAuth } from 'react-firebaseui';

import firebase, { auth } from './base';

export default class extends Component {
  constructor(props) {
    super(props);

    this.uiConfig = {
      // Popup signin flow rather than redirect flow.
      signInFlow: 'popup',
      // We will display Google, Phone and Email as auth providers.
      signInOptions: [
        {
          provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          customParameters: {
            prompt: 'select_account',
          }
        }, {
          provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
          requireDisplayName: true
        }/*, {
          provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
          recaptchaParameters: {
            type: 'image', // 'image' or 'audio'
            size: 'invisible', // 'normal', 'invisible' or 'compact'
            badge: 'inline' // 'bottomleft', 'bottomright' or 'inline' applies to invisible.
          },
          defaultCountry: 'BR', // Set default country to the Brazil (+55).
          // For prefilling the national number, set defaultNationNumber.
          // This will only be observed if only phone Auth provider is used since
          // for multiple providers, the NASCAR screen will always render first
          // with a 'sign in with phone number' button.
        }, */
      ],
      // Sets the `signedIn` state property to `true` once signed in.
      callbacks: {
        signInSuccess: () => {
          return false; // Avoid redirects after sign-in.
        }
      }
    };
  }

  render() {
    let {
      auth: { fetching }
    } = this.props;

    return (
      2 !== fetching && (
        <FirebaseAuth uiConfig={this.uiConfig} firebaseAuth={auth} />
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/SignIn.js